var tabDropList = {
  model: function () {

  },

  //{
  //     dropList: null,
  //     dropIcon: null,
  //   },
  beforeDrop:null,

  showDropList: function (id) {

    if (this.beforeDrop && this.beforeDrop.id != id){
      //关闭上一个展开菜单
      this.beforeDrop.dropList.classList.add('hide');
      this.beforeDrop.dropList.setAttribute('data-drop-status', 'false');

      this.beforeDrop.dropIcon.classList.remove('tab-dropdown-list-icon-down');
      this.beforeDrop.dropIcon.setAttribute('data-drop-status', 'false');

    }

    var dropList = document.querySelector('#'+id);
    var dropStatus = dropList.getAttribute('data-drop-status');
    var dropIcons = document.querySelectorAll('.tab-dropdown-list-icon');
    var mask = document.querySelector('.tab-drop-mask');

    mask.addEventListener('click', function () {
      if (tabDropList.beforeDrop) {
          tabDropList.showDropList(tabDropList.beforeDrop.id);
      }
    });

    var dropIcon = '';
    if(dropIcons.length>1){
      var dropIconsArr = [];
      for ( var i=0; i<dropIcons.length; i++){
        dropIconsArr.push(dropIcons[i]);
      }
      dropIconsArr.forEach(function (item) {
        if(item.getAttribute('data-drop-inst') === dropList.getAttribute('data-drop-inst')){
          dropIcon = item;
        }
      });
    }else{
      dropIcon = dropIcons[0];
    }


    function  filterDropIcon(dropIcon) {
      return dropIcon.getAttribute('data-drop-inst') === dropList.getAttribute('data-drop-inst');
    }

    if (this.beforeDrop && this.beforeDrop.id == id){
      //清除上一次展开菜单
      this.beforeDrop = null;
    }else{
      //记录上一次展开菜单
      this.beforeDrop = {
        id: id,
        dropList: dropList,
        dropIcon: dropIcon,
      }
    }

    if(dropStatus === 'false'){
      dropList.classList.remove('hide');
      dropIcon.classList.add('tab-dropdown-list-icon-down');
      dropList.setAttribute('data-drop-status', 'true');
      dropIcon.setAttribute('data-drop-status', 'true');
      setScroll.unScroll();
      mask.setAttribute('style','display: block')
    }else{
      dropList.classList.add('ani-droplist-hide');
        setScroll.removeUnScroll();
        mask.setAttribute('style','display: none')
      setTimeout(function () {
        dropList.classList.add('hide');
        dropList.classList.remove('ani-droplist-hide');
        dropList.setAttribute('data-drop-status', 'false');

        dropIcon.classList.remove('tab-dropdown-list-icon-down');
        dropIcon.setAttribute('data-drop-status', 'false');

      },100);
    }

    var dropIcon = dropList.previousElementSibling;
    dropIcon.classList.add('tab-dropdown-list-icon-down');

  },

  setStatus: function(){

  },

  init: function () {
    this.model();
  }
};
